<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { computed } from 'vue';

type BadgeSize = 'sm' | 'md' | 'lg';
type BadgePosition = 'overlay' | 'inline';

const props = withDefaults(
  defineProps<{
    size?: BadgeSize;
    position?: BadgePosition;
    rounded?: boolean;
    variant?: string; // Generic styling variant, passed as additional classes
  }>(),
  {
    size: 'sm',
    position: 'inline',
    rounded: true,
    variant: ''
  }
);

const badgeClasses = computed(() => {
  const classes = [];

  // Base classes
  classes.push('inline-flex items-center justify-center font-bold');

  // Rounded corners
  if (props.rounded) {
    classes.push('rounded');
  }

  // Size classes
  switch (props.size) {
    case 'sm':
      classes.push('px-2 py-1 text-xs');
      break;
    case 'md':
      classes.push('px-3 py-1 text-sm');
      break;
    case 'lg':
      classes.push('px-4 py-2 text-base');
      break;
  }

  // Position classes
  if (props.position === 'overlay') {
    classes.push('absolute z-10');
  }

  // Add any additional variant classes
  if (props.variant) {
    classes.push(props.variant);
  }

  return classes.join(' ');
});
</script>

<template>
  <span :class="badgeClasses">
    <slot />
  </span>
</template>
